(() => {
  const desktopMedia = window.matchMedia('(min-width: 990px)');
  const menuSelector = '.header__inline-menu header-menu';
  const hoverDelay = 175;
  const initializedMenus = new WeakSet();

  const initializeMenu = (menu) => {
    if (initializedMenus.has(menu)) return;

    const details = menu.querySelector(':scope > details');
    const summary = details?.querySelector(':scope > summary');

    if (!details || !summary) return;

    initializedMenus.add(menu);

    let openTimer;
    let closeTimer;
    let pointerInside = false;
    let lastInteraction = 'pointer';

    const clearOpenTimer = () => {
      window.clearTimeout(openTimer);
      openTimer = undefined;
    };

    const clearCloseTimer = () => {
      window.clearTimeout(closeTimer);
      closeTimer = undefined;
    };

    const syncExpandedState = () => {
      summary.setAttribute('aria-expanded', String(details.open));
    };

    const openMenu = () => {
      if (!desktopMedia.matches || !pointerInside || details.open) return;

      details.open = true;
      syncExpandedState();
    };

    const closeMenu = () => {
      if (!desktopMedia.matches || pointerInside) return;
      if (lastInteraction === 'keyboard' && menu.contains(document.activeElement)) return;

      if (typeof menu.close === 'function') {
        menu.close();
      } else {
        details.open = false;
        syncExpandedState();
      }
    };

    menu.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse' || !desktopMedia.matches) return;

      pointerInside = true;
      lastInteraction = 'pointer';
      clearCloseTimer();

      if (details.open) return;

      clearOpenTimer();
      openTimer = window.setTimeout(openMenu, hoverDelay);
    });

    menu.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse' || !desktopMedia.matches) return;

      pointerInside = false;
      clearOpenTimer();
      clearCloseTimer();
      closeTimer = window.setTimeout(closeMenu, hoverDelay);
    });

    menu.addEventListener('keydown', () => {
      lastInteraction = 'keyboard';
    });

    summary.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') return;

      lastInteraction = 'pointer';
      clearOpenTimer();
    });

    details.addEventListener('toggle', syncExpandedState);

    desktopMedia.addEventListener('change', (event) => {
      if (event.matches) return;

      pointerInside = false;
      clearOpenTimer();
      clearCloseTimer();

      if (typeof menu.close === 'function') {
        menu.close();
      } else {
        details.open = false;
        syncExpandedState();
      }
    });
  };

  const initializeMenus = (root = document) => {
    root.querySelectorAll?.(menuSelector).forEach(initializeMenu);
  };

  initializeMenus();

  document.addEventListener('shopify:section:load', (event) => {
    initializeMenus(event.target);
  });
})();
